import { ActionType } from '../../../stores/action-types';
import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React, { useCallback } from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { exportGnuplotCharts } from  '../../../stores/actions/exportActions';
import { connect } from 'react-redux';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import Node from '@material-ui/icons/Memory';
import utils from '../../../helpers/GlobalVariables';
import { Account, ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DoneAll from '@material-ui/icons/DoneAll';
import { InputAdornment } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import _ from 'lodash';
import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';

import './Export.css';

interface IExportGnuplotChartsProps {
    account: Account;
    classes: ClassNameMap;
    exportFailed: boolean;
    exportFailedNoData: boolean;
    mobileView: boolean;
    isFileExporting: boolean;
    exportGnuplotCharts: (sysID, nodesIds, nodeIdsAdv, sysName, fromDate, toDate, format, chartType) => void;
    systems: ISystem[];
    systemsNodesShort: any[];
}

const ExportGnuplotCharts = ({
    exportFailed,
    exportFailedNoData,
    mobileView,
    exportGnuplotCharts,
    systems,
    account,
    isFileExporting,
    systemsNodesShort,
    ...props
}: IExportGnuplotChartsProps) => {
    const { classes } = props;
    const [pickedSystem, setPickedSystem] = useState<number|null|undefined>(null);
    let today = new Date()
    let yearAgo = new Date((new Date(today)).setFullYear(today.getFullYear() - 1));

    const [date, setDate] = useState([yearAgo, today]);
    const [dateError, setDateError] = useState(false);
    const [systemNodesIds, setSystemNodesIds] = useState([]);
    const [systemNodesNamesByIds, setSystemNodesNamesByIds] = useState([]);
    const dispatch = useDispatch();
    const closeNotificationTimer = useRef(null);
    const systemIds = systems.map(el => el.ID);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name])); 
    const [pickedNodes, setPickedNodes] = useState([]);
    const [pickedNodesAdvanced, setPickedNodesAdvanced] = useState([]);
    const [format, setFormat] = useState('png');
    const [chartType, setChartType] = useState('line');
    const allNodesSelected = pickedNodes.length === systemNodesIds.length;
    const closeExportNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_EXPORT_NOTIFICATION });
    }, [dispatch]);

    useEffect(() => {
        if (exportFailed || isFileExporting || exportFailedNoData) {
            closeNotificationTimer.current = setTimeout(closeExportNotification, 6000);
        }
        return () => {
            clearTimeout(closeNotificationTimer.current);
        };
    }, [closeExportNotification, exportFailed, isFileExporting, exportFailedNoData]);

    useEffect(() => {
        setDateError(!date || !date[0] || !date[1] || date[0] > date[1])
    }, [date]);

    useEffect(() => {
        let nodes = [];
        let nodesIds = [];
        let nodesNamesByIds = [];
        if (pickedSystem) {
            nodes = _.filter(systemsNodesShort, { systemId: pickedSystem });
            nodesIds = nodes.map(el => el.nodeId);
            nodesNamesByIds = Object.fromEntries(nodes.map(x => [x.nodeId, x.nodeName]));
        }
        setSystemNodesIds(nodesIds);
        setSystemNodesNamesByIds(nodesNamesByIds);
        setPickedNodes([]);
        setPickedNodesAdvanced([]);
    }, [pickedSystem]);

    const handleSelectAll = () => {
        let nodes = [];
        let nodesIds = [];
        if (pickedSystem) {
            nodes = _.filter(systemsNodesShort, { systemId: pickedSystem });
            nodesIds = nodes.map(el => el.nodeId);
            setPickedNodes(nodesIds);
        }
    }
    const exportButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: exportFailed ? '5px' : '25px', transition: 'color 0.3s' }}
                disabled={!pickedSystem || dateError || !pickedNodes?.length || pickedNodesAdvanced?.length && pickedNodesAdvanced.length != 2}
                onClick={(e) => {
                    exportGnuplotCharts(pickedSystem, pickedNodes, pickedNodesAdvanced, systemNamesByIds[pickedSystem], date[0], date[1], format ?? 'png', chartType ?? 'line') 
                }}
            >
                Export
            </Button>
        );
    };

    const renderMobileNotifications = (): JSX.Element => {
        const headerStyle = utils.getHeaderStyle(exportFailed || exportFailedNoData);

        if (!mobileView) return null;
        if (exportFailed || isFileExporting || exportFailedNoData) {
            const className = exportFailed || exportFailedNoData ? 'notification-open-create-account-fail' : 'notification-open-create-account-success';
            return (
                <h5 className={className} style={headerStyle}>
                    {exportFailed
                        ? "Export failed."
                        : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                </h5>
            );
        }
        return <div style={utils.emptyHeaderStyle}></div>;
    };
    const handleDateRangePickerRender = () => {
        return (
            <DateRangePicker
                locale="en-US"
                onChange={(val) => setDate(val)}
                value={date}
                format="y-MM-dd"
                clearIcon={null}
                autoFocus={false}
                minDate={new Date('2010-01-01')}
                maxDate={new Date()}
                style={{ width: "100%" }}
   
            />
        )
    }
    return (
        <Card className='exportmeasurementsForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Node />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Gnuplot Charts</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()} disabled={!systems || !systems.length}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemIds}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystem}
                            onChange={(e, newVal) => setPickedSystem(newVal)}
                            renderInput={(systemIds) => <TextField {...systemIds} label='System' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                        <Autocomplete
                            options={systemNodesIds}
                            multiple
                            disableCloseOnSelect
                            value={pickedNodes}
                            onChange={(e, newVal) => setPickedNodes(newVal)}
                            getOptionLabel={(id) => systemNodesNamesByIds[id]}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Nodes (Standard)"
                                margin="normal"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                    <>
                                        <InputAdornment>
                                        { allNodesSelected ? null :
                                        <IconButton onClick={handleSelectAll} size="small" title={'Select all'}>
                                            <DoneAll color={'primary'} />
                                        </IconButton> }
                                        </InputAdornment>
                                        {params.InputProps.endAdornment}
                                    </>
                                    ),
                                }}
                                />
                            )}
                            style={{ width: '100%' }}
                            />
                        <Autocomplete
                            options={systemNodesIds}
                            multiple
                            disableCloseOnSelect
                            value={pickedNodesAdvanced}
                            onChange={(e, newVal) => setPickedNodesAdvanced(newVal)}
                            getOptionLabel={(id) => systemNodesNamesByIds[id]}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Nodes (Advanced - 2 nodes for comaprison)"
                                margin="normal"
                                />
                            )}
                            style={{ width: '100%' }}
                            />
                    </div>
                    <div>
                    <Autocomplete
                            options={['png', 'pdf']}
                            disableClearable
                            value={format ?? 'png'}
                            onChange={(e, newVal) => setFormat(newVal)}
                            getOptionLabel={(f) => f}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Chart file type"
                                margin="normal"
                                />
                            )}
                            style={{ width: '40%' }}
                            />
                        <Autocomplete
                            options={['line', 'points']}
                            disableClearable
                            value={chartType ?? 'line'}
                            onChange={(e, newVal) => setChartType(newVal)}
                            getOptionLabel={(t) => t}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Chart type"
                                margin="normal"
                                />
                            )}
                            style={{ width: '40%' }}
                            />
                    </div>
                    <div>
                        {handleDateRangePickerRender()}
                    </div>
                </FormControl>
                {renderMobileNotifications()}
                {exportButton()}
            </CardBody>
            {!mobileView ? (
                <>
                    <Snackbar
                        close
                        closeNotification={() => closeExportNotification()}
                        color={exportFailed || exportFailedNoData ? 'danger' : 'success'}
                        message={exportFailed ? 'Export failed.' : ( exportFailedNoData ? 'Nothing to export' : 'Export will begin shortly.')}
                        open={exportFailed || isFileExporting || exportFailedNoData}
                        place='tc'
                    />
                </>
            ) : null}
        </Card>
    );
};

const mapStateToProps = (state) => ({
    exportFailed: state.dashboard.exportFailed,
    exportFailedNoData: state.dashboard.exportFailedNoData,
    isFileExporting: state.dashboard.isFileExporting,
    mobileView: state.dashboard.mobileView
});
const actions = {
    exportGnuplotCharts,
};

const ExportGnuplotChartsWithStyles = regularFormsStyle(ExportGnuplotCharts);
export default connect(mapStateToProps, actions)(ExportGnuplotChartsWithStyles);
